import { module as BaseModule } from "modujs";

const SELECTORS = {
  trigger: "[data-sticky-header-end]",
};

const CLASSES = {
  visible: "has-sticky-nav-visible",
  hiding: "has-sticky-nav-hiding",
};

const HIDE_DURATION = 350;

export default class StickyHeader extends BaseModule {
  init() {
    this.trigger = this.el.querySelector(SELECTORS.trigger);

    if (!this.trigger) {
      return;
    }

    this.rafId = null;
    this.hideTimeout = null;
    this.isVisible = false;
    this.handleScroll = this.handleScroll.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.runUpdate = this.runUpdate.bind(this);

    window.addEventListener("scroll", this.handleScroll, { passive: true });
    window.addEventListener("resize", this.handleResize);
    this.update();
  }

  handleScroll() {
    this.requestUpdate();
  }

  handleResize() {
    this.requestUpdate();
  }

  requestUpdate() {
    if (this.rafId) {
      return;
    }

    this.rafId = window.requestAnimationFrame(this.runUpdate);
  }

  runUpdate() {
    this.rafId = null;
    this.update();
  }

  update() {
    if (!this.trigger) {
      return;
    }

    const rect = this.trigger.getBoundingClientRect();
    const shouldShow = rect.top <= 0;

    if (shouldShow) {
      this.showSticky();
      return;
    }

    this.hideSticky();
  }

  showSticky() {
    if (this.hideTimeout) {
      window.clearTimeout(this.hideTimeout);
      this.hideTimeout = null;
    }

    if (this.isVisible) {
      this.el.classList.remove(CLASSES.hiding);
      this.el.classList.add(CLASSES.visible);
      return;
    }

    this.isVisible = true;
    this.el.classList.remove(CLASSES.hiding);
    this.el.classList.add(CLASSES.visible);
  }

  hideSticky() {
    if (!this.isVisible) {
      this.el.classList.remove(CLASSES.hiding);
      this.el.classList.remove(CLASSES.visible);
      return;
    }

    if (this.hideTimeout) {
      return;
    }

    this.el.classList.add(CLASSES.hiding);
    this.el.classList.remove(CLASSES.visible);

    this.hideTimeout = window.setTimeout(() => {
      this.isVisible = false;
      this.hideTimeout = null;
      this.el.classList.remove(CLASSES.hiding);
    }, HIDE_DURATION);
  }

  destroy() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.handleResize);

    if (this.rafId) {
      window.cancelAnimationFrame(this.rafId);
      this.rafId = null;
    }

    if (this.hideTimeout) {
      window.clearTimeout(this.hideTimeout);
      this.hideTimeout = null;
    }

    this.el.classList.remove(CLASSES.visible);
    this.el.classList.remove(CLASSES.hiding);
    this.trigger = null;
    this.isVisible = false;
  }
}
